import React, { FC } from "react";
import { Link, Typography } from "@mui/material";
import "./navbar.style.scss";
import { colors } from "../../constants/site-content";

export const ContactInfo: FC = () => (
  <>
    <Link sx={{ cursor: "pointer", textDecoration: "none" }} href="mailto:croqee@gmail.com">
      <Typography
        sx={{ color: colors.brandColor, fontSize: "20px"}}
        variant="inherit"
      >
        croqee@gmail.com
      </Typography>
    </Link>
  </>
);
